exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".load-mask-parent{min-height:350px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-36a89b5c!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/CustomModule/index.vue
// module id = 868
// module chunks = 2